import { Loader2 } from "@/components/icons";

export function CheckoutRedirectOverlay({
  isRedirecting,
}: {
  isRedirecting: boolean;
}) {
  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center gap-3 bg-background/95 backdrop-blur-sm">
      <Loader2 className="size-8 animate-spin text-muted-foreground" />
      <p className="text-sm font-medium">
        {isRedirecting
          ? "Opening checkout…"
          : "Reserving your items…"}
      </p>
    </div>
  );
}
